import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  showSpinner = false;

  constructor(private spinnerService: SpinnerService, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit(): void {

    this.inicializar();
  }

  inicializar(){

    this.spinnerService.getSpinnerObservable().subscribe((status) => {

      this.showSpinner = (status === 'inicio');
      this.cdRef.detectChanges();
    })
  }
}
